// extracted by mini-css-extract-plugin
export default {"homeButton":"CastleFront_homeButton__wYA1Q","mapButton":"CastleFront_mapButton__-olhO","button":"CastleFront_button__4Tnv6"};